// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PasswordSuggesterController from "./password_suggester_controller"
application.register("password-suggester", PasswordSuggesterController)

import RefreshCountdownController from "./refresh_countdown_controller"
application.register("refresh-countdown", RefreshCountdownController)

import ReportFilterController from "./report_filter_controller"
application.register("report-filter", ReportFilterController)

import SortableListController from "./sortable_list_controller"
application.register("sortable-list", SortableListController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
